var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_926_1140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8245 9.20731C17.8245 8.59552 17.7749 7.98041 17.6691 7.37854H9.17999V10.8443H14.0413C13.8396 11.962 13.1914 12.9508 12.2423 13.5792V15.8279H15.1425C16.8456 14.2604 17.8245 11.9455 17.8245 9.20731Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17998 18.0006C11.6073 18.0006 13.6544 17.2036 15.1458 15.8279L12.2456 13.5792C11.4387 14.1281 10.397 14.439 9.18329 14.439C6.83532 14.439 4.84451 12.8549 4.13019 10.7252H1.13736V13.0434C2.66519 16.0826 5.77708 18.0006 9.17998 18.0006V18.0006Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1269 10.7252C3.7499 9.60745 3.7499 8.39709 4.1269 7.27933V4.96112H1.13737C-0.139133 7.5042 -0.139133 10.5003 1.13737 13.0434L4.1269 10.7252V10.7252Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17998 3.56225C10.4631 3.5424 11.7032 4.02523 12.6325 4.9115L15.202 2.34196C13.575 0.814129 11.4155 -0.0258495 9.17998 0.000606499C5.77708 0.000606499 2.66519 1.91867 1.13736 4.96111L4.12689 7.27931C4.83789 5.1463 6.83201 3.56225 9.17998 3.56225V3.56225Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_926_1140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.07ca530e6bb99db0f9822cad1f01e46a.svg";
export { ForwardRef as ReactComponent };